import React, { useEffect, useState } from 'react';
import lmsApi from '../../services/api';
import LoanCard from '../../components/LoanCard';
import PaymentModal from '../../components/PaymentModal';
import LMSTopBar from '../../components/LMSTopBar';
import { toast } from 'sonner';

const LMSDashboard = () => {
    const [loans, setLoans] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [selectedLoan, setSelectedLoan] = useState<any>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const fetchLoans = async () => {
        try {
            const response = await lmsApi.post('/loans/');
            setLoans(response.data);
        } catch (error) {
            console.error("Fetch Loans Error", error);
            toast.error("Failed to fetch loans. Please login again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLoans();
    }, []);

    const handlePayClick = (loan: any) => {
        setSelectedLoan(loan);
        setIsModalOpen(true);
    };

    if (loading) {
        return <div className="p-8 text-center">Loading...</div>;
    }

    return (
        <div className="min-h-screen bg-gray-50 pb-20">
            <LMSTopBar title="My Loans" />

            <main className="max-w-4xl mx-auto px-4">
                {loans.length === 0 ? (
                    <div className="text-center py-10 text-gray-500">
                        No active loans found.
                    </div>
                ) : (
                    <div className="grid gap-6 md:grid-cols-2">
                        {loans.map((loan) => (
                            <LoanCard
                                key={loan.id}
                                loan={loan}
                                onPayClick={handlePayClick}
                            />
                        ))}
                    </div>
                )}
            </main>

            {selectedLoan && (
                <PaymentModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    loan={selectedLoan}
                    onPaymentSuccess={fetchLoans}
                />
            )}
        </div>
    );
}

export default LMSDashboard;
